export default "__VITE_ASSET__CBJbbSaY__"